export default "__VITE_ASSET__9d461bf7__"